const icon = {
  styleOverrides: {
    fontSizeSmall: {
      width: '1.25rem',
      height: '1.25rem'
    }
  }
};

export default icon;
